import styled from 'styled-components'

export const CloseButton = styled.div`
  cursor: pointer;
  border-radius: 25%;
  background-color: white;
  padding: 5px;
`